/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
import { Component, inject, OnInit, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { LoadingPanelService } from '../../shared/loading-panel/loading-panel.service';
import { TestToolService } from '../services/test-tool.service';
import { CurrentUserService } from '../../user/services';
import { ActivatedRoute } from '@angular/router';
import { TestCaseInterchangeDto } from '../models/test-case-interchange-dto';
import { GridService } from '../../shared/grid/grid.service';
import { TestFileDto, TestFileType } from '../models/test-file-dto';
import { ToastService, ToastType } from '../../shared/toast/toast.service';
import { JsonHttpService } from '../../shared/http/json-http.service';
import { DistributionService } from '../../distribution/services/distribution.service';
import { DocumentEncoding } from '../../distribution/models';
import { InitConfiguration } from '../../distribution/models/init-configuration';
import { ModalDismissStatus } from '../../distribution/models/modal-dismiss-status';
import { InitConfigurationDialogComponent } from '../../distribution/init-configuration-dialog/init-configuration-dialog.component';
import { GenericModalService, ModalSettingsTemplate } from '../../shared/generic-modal/generic-modal.service';
import { SvgIconComponent } from '../../shared/icons/svg-icon.component';
import { DxDataGridComponent, DxDataGridModule } from 'devextreme-angular';
import { BizDataGridDirective } from '../../shared/grid/biz-grid.directive';
import { DxoMasterDetailModule, DxoEditingModule, DxoTextsModule, DxoFormModule, DxiItemModule, DxiColumnModule, DxiValidationRuleModule, DxiButtonModule } from 'devextreme-angular/ui/nested';
import { BizUserColumnDirective } from '../../shared/grid/biz-grid-user.directive';
import { BizDateColumnDirective } from '../../shared/grid/biz-grid-date.directive';
import { DxTemplateModule } from 'devextreme-angular/core';
import { TestToolTestCaseInterchangeExpectedOutputFilesComponent } from '../test-tool-test-case-interchange-expected-output-files/test-tool-test-case-interchange-expected-output-files.component';
import { FileUploaderComponent } from '../../shared/upload/file-uploader.component';

import { EncodingPickerComponent } from '../../shared/encoding/encoding-picker.component';
import { BizGridFiltervalues } from 'src/app/shared/grid/biz-grid-filtervalues';
import { DeveloperService } from 'src/app/developer/services/developer.service';
import { ContentType } from 'src/app/distribution/models/content-type';
import { EncodingPickerService } from 'src/app/shared/encoding/encoding-picker.service';

@Component({
    selector: 'app-test-tool-test-case-interchanges',
    templateUrl: './test-tool-test-case-interchanges.component.html',
    styleUrls: ['./test-tool-test-case-interchanges.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    SvgIconComponent,
    DxDataGridModule,
    BizDataGridDirective,
    DxoMasterDetailModule,
    DxoEditingModule,
    DxoTextsModule,
    DxoFormModule,
    DxiItemModule,
    DxiColumnModule,
    DxiValidationRuleModule,
    BizUserColumnDirective,
    BizDateColumnDirective,
    DxiButtonModule,
    DxTemplateModule,
    TestToolTestCaseInterchangeExpectedOutputFilesComponent,
    FileUploaderComponent,
    EncodingPickerComponent
]
})
export class TestToolTestCaseInterchangesComponent implements OnInit {
    public grid = viewChild(DxDataGridComponent);
    public bizGridFiltervalues = inject(BizGridFiltervalues);

    private developerService = inject(DeveloperService);
    private distributionService = inject(DistributionService);
    private route = inject(ActivatedRoute);
    private loadingPanelService = inject(LoadingPanelService);
    private testToolService = inject(TestToolService);
    private toastService = inject(ToastService);
    private currentUserService = inject(CurrentUserService);
    private jsonHttpService = inject(JsonHttpService);
    private modalService = inject(GenericModalService);
    private gridService = inject(GridService);
    private encodingPickerService = inject(EncodingPickerService);

    private expandInterchangeId?: number;
    private pendingExpandKey: number | string | null = null;

    allowAdding = false;
    allowUpdating = false;
    allowDeleting = false;

    currentTestCaseId: number;
    currentTestCaseName: string;
    currentTestCaseInterchanges: TestCaseInterchangeDto[] = []
    currentUploadedInterchangeInDataGuid: string | null;
    currentUploadedInitCondigDataGuid: string | null;
    currentUploadedContextPropertiesDataGuid: string | null;
    encodings: DocumentEncoding[] = [];
    contentTypes: ContentType[] = [];

    ngOnInit() : void {
        this.route.params.subscribe((parms: any) => {
              this.currentTestCaseId = parms.testCaseId as number;
              this.currentTestCaseName = parms.testCaseName as string ?? '';

              if (parms.expandInterchangeId) {
                this.expandInterchangeId = Number(parms.expandInterchangeId);
              }
          });

        void this.refresh();
    }

    async refresh() {
        this.loadingPanelService.showLoadingPanelDirect('Loading Test Case Interchanges...');

        const [currentTestCaseInterchanges, encodings, contentTypes] = await Promise.all([
            this.testToolService.getTestCaseInterchangesForTestCase(this.currentTestCaseId),
            this.distributionService.getDocumentEncodings(),
            this.developerService.getContentTypes()
        ]);

        this.currentTestCaseInterchanges = currentTestCaseInterchanges;

        // Defer actual work to grid's contentReady
        this.pendingExpandKey = this.expandInterchangeId ?? null;

        this.encodings = encodings.sort((a, b) => a.DisplayName.localeCompare(b.DisplayName));
        this.contentTypes = contentTypes.sort((a, b) => a.Name.localeCompare(b.Name));

        this.allowAdding = this.currentUserService.hasPermission('TestTool_Action_TestCase_Create');
        this.allowUpdating = this.currentUserService.hasPermission('TestTool_Action_TestCase_Edit');
        this.allowDeleting = this.currentUserService.hasPermission('TestTool_Action_TestCase_Delete');
        this.loadingPanelService.hideLoadingPanel();
    }

    downloadExpectedFiles = async (e: any): Promise<void> => {
        const testCaseInterchangeDto = e.row.data as TestCaseInterchangeDto;
        await this.testToolService.downloadTestCaseInterchange(testCaseInterchangeDto.Id);
    }

    fileOnValueChangedCallback(args: any, cellInfo: any) {
        if (args.value.length > 0) {
            cellInfo.setValue(args.value[0].name);
        }
        else {
            cellInfo.setValue(null);
        }
    }

    fileOnBeforeSendCallback(args: any, cellInfo: any): void {
        const request = args.request as XMLHttpRequest;
        const headers = this.jsonHttpService.generateHeaders();
        request.setRequestHeader('Authorization', headers.get('Authorization'));
    }

    fileOnUploadedCallback(args: any, cellInfo: any) {
        if (args.request.status === 200) {
            const uploadGuid = JSON.parse(args.request.responseText);
            const fileType = cellInfo.column.dataField;
            if (fileType === 'InterchangeIn.Filename') {
                this.currentUploadedInterchangeInDataGuid = uploadGuid;
            } else if (fileType === 'InitConfiguration.Filename') {
                this.currentUploadedInitCondigDataGuid = uploadGuid;
            } else if (fileType === 'ContextProperties.Filename') {
                this.currentUploadedContextPropertiesDataGuid = uploadGuid;
            }
        }
    }

    getCorrectEncodingId(cellInfo: any) : number | null {
        const fileType = cellInfo.column.dataField;
        if (fileType === 'InterchangeIn.EncodingId') {
            return cellInfo.data.InterchangeIn?.EncodingId;
        } else if (fileType === 'InitConfiguration.EncodingId') {
            return cellInfo.data.InitConfiguration?.EncodingId;
        } else if (fileType === 'ContextProperties.EncodingId') {
            return cellInfo.data.ContextProperties?.EncodingId;
        }
        return null;
    }

    getCorrectFilename(cellInfo: any) : string | null {
        const fileType = cellInfo.column.dataField;
        if (fileType === 'InterchangeIn.Filename') {
            return cellInfo.data.InterchangeIn.Filename;
        } else if (fileType === 'InitConfiguration.Filename') {
            return cellInfo.data?.InitConfiguration?.Filename;
        } else if (fileType === 'ContextProperties.Filename') {
            return cellInfo.data?.ContextProperties?.Filename;
        }
        return null;
    }

    setEncodingId(encodingId: number, cellInfo: any) {
        cellInfo.setValue(encodingId || null);
    }

    onInitNewRow(e: any): void {
        e.data = {
            Id: 0,
            TestCaseId: this.currentTestCaseId,
            InterchangeIn: {
                Id: 0,
                FileType: TestFileType.TypeOriginalInterchangeIn,
                ContentTypeId: null,
                EncodingId: null,
                Filename: null,
                Note: null
            } as TestFileDto,
            InitConfiguration: {
                Id: 0,
                FileType: TestFileType.TypeOriginalInitConfiguration,
                ContentTypeId: null,
                EncodingId: null,
                Filename: null,
                Note: null
            } as TestFileDto,
            ContextProperties: {
                Id: 0,
                FileType: TestFileType.TypeOriginalInterchangeInContextProperties,
                ContentTypeId: null,
                EncodingId: null,
                Filename: null,
                Note: null
            } as TestFileDto,
            Note: null
        } as TestCaseInterchangeDto;
    }

    onRowInserting = (e: any): void => {
        e.cancel = this.gridService.handleDataGridRow(e.data as TestCaseInterchangeDto, item => this.saveTestCaseInterchangeDto(item));
    };

    onRowUpdating = (e: any): void => {
        // The spread operator only does a shallow copy, so TestCaseInterchangeDto files will only be e.newData and therefore we would lose data if we don't do this in multiple steps.
        const testCaseInterchangeDto = { ...e.oldData, ...e.newData } as TestCaseInterchangeDto;
        const interchangeInTestFileDto = { ...e.oldData.InterchangeIn, ...e.newData.InterchangeIn } as TestFileDto
        const initConfigurationTestFileDto = { ...e.oldData.InitConfiguration, ...e.newData.InitConfiguration } as TestFileDto
        const contextPropertiesTestFileDto = { ...e.oldData.ContextProperties, ...e.newData.ContextProperties } as TestFileDto
        testCaseInterchangeDto.InterchangeIn = interchangeInTestFileDto;
        testCaseInterchangeDto.InitConfiguration = initConfigurationTestFileDto;
        testCaseInterchangeDto.ContextProperties = contextPropertiesTestFileDto;
        e.cancel = this.gridService.handleDataGridRow(testCaseInterchangeDto, item => this.saveTestCaseInterchangeDto(item), e.newData);
    };

    onRowRemoving = (e: any): void => {
        e.cancel = this.gridService.handleDataGridRow(e.data as TestCaseInterchangeDto, item => this.deleteTestCaseInterchangeDto(item));
    };

    onGridContentReady(): void {
        if (!this.pendingExpandKey || !this.grid()?.instance) return;

        const key = this.pendingExpandKey;
        this.grid().instance.expandRow(key);
        const rowIndex = this.grid().instance.getRowIndexByKey(key);
        if (rowIndex >= 0) {
            this.grid().instance.navigateToRow(key);
        }
        this.pendingExpandKey = null; // run once
    }

    encodingDisplayExpr = (item?: DocumentEncoding) =>
        this.encodingPickerService.formatEncodingDisplay(item);

    async saveTestCaseInterchangeDto(testCaseInterchangeDto: TestCaseInterchangeDto): Promise<TestCaseInterchangeDto> {
        testCaseInterchangeDto.InterchangeIn.UploadFileGuid = this.currentUploadedInterchangeInDataGuid;
        testCaseInterchangeDto.InitConfiguration.UploadFileGuid = this.currentUploadedInitCondigDataGuid;
        testCaseInterchangeDto.ContextProperties.UploadFileGuid = this.currentUploadedContextPropertiesDataGuid;
        const newTestCaseInterchangeDto = await this.testToolService.saveTestCaseInterchange(testCaseInterchangeDto);
        this.toastService.showToast('Test case interchange saved...', ToastType.success);
        this.currentUploadedInterchangeInDataGuid = null;
        this.currentUploadedInitCondigDataGuid = null;
        this.currentUploadedContextPropertiesDataGuid = null;
        return newTestCaseInterchangeDto;
    }

    async deleteTestCaseInterchangeDto(testCaseInterchangeDto: TestCaseInterchangeDto): Promise<TestCaseInterchangeDto> {
         await this.testToolService.deleteTestCaseInterchange(testCaseInterchangeDto.Id, false);
        this.toastService.showToast('Test case interchange deleted...', ToastType.success);
        return testCaseInterchangeDto;
    }

    async editInitConfig(testCaseInterchange: TestCaseInterchangeDto) {
        let initConfiguration = await this.testToolService.getTestCaseInterchangeInitConfig(testCaseInterchange.Id);
        initConfiguration = initConfiguration ?? { FormatTypeId: null } as InitConfiguration;

        const componentValues = {
            initConfiguration: initConfiguration,
            headline: 'Test Case Interchange',
            showDelete: testCaseInterchange.InitConfiguration !== null
        };

        this.modalService.openComponentType<InitConfiguration>(InitConfigurationDialogComponent, componentValues, new ModalSettingsTemplate('lg', 'static')).then(async result => {
            this.loadingPanelService.showLoadingPanelDirect('Saving init configuration...');
            initConfiguration = await this.testToolService.saveTestCaseInterchangeInitConfig(testCaseInterchange.Id, result);
            void this.refresh();
            this.loadingPanelService.hideLoadingPanel();
        }).catch((reason: ModalDismissStatus) => {
            if (reason === ModalDismissStatus.Delete) { // If the delete button has been pressed...
                this.modalService.confirmDirect('Delete', 'Delete init-config for test case interchange?').then(async () => {
                    this.loadingPanelService.showLoadingPanelDirect('Deleting init configuration...');
                    await this.testToolService.deleteTestCaseInterchangeInitConfig(testCaseInterchange.Id);
                    void this.refresh();
                    this.loadingPanelService.hideLoadingPanel();
                }).catch(() => { });
            }
        });
    }
}
